/*@ngInject*/
const UIReloadRelativeTimeDirective = function ($interval, $filter, localization) {

    localization.setupLocale('uiReloadRelativeTime', require('./uiReloadRelativeTime.i18n.json'));

    moment.updateLocale('en', {
        relativeTime : {
            future: i18n.t('uiReloadRelativeTime|relativeTime.future'),
            past: i18n.t('uiReloadRelativeTime|relativeTime.past'),
            s: i18n.t('uiReloadRelativeTime|relativeTime.s'),
            ss: i18n.t('uiReloadRelativeTime|relativeTime.ss'),
            m: i18n.t('uiReloadRelativeTime|relativeTime.m'),
            mm: i18n.t('uiReloadRelativeTime|relativeTime.mm'),
            h: i18n.t('uiReloadRelativeTime|relativeTime.h'),
            hh: i18n.t('uiReloadRelativeTime|relativeTime.hh'),
            d: i18n.t('uiReloadRelativeTime|relativeTime.d'),
            dd: i18n.t('uiReloadRelativeTime|relativeTime.dd'),
            M: i18n.t('uiReloadRelativeTime|relativeTime.M'),
            MM: i18n.t('uiReloadRelativeTime|relativeTime.MM'),
            y: i18n.t('uiReloadRelativeTime|relativeTime.y'),
            yy: i18n.t('uiReloadRelativeTime|relativeTime.yy')
        }
    });

    let linkFunction = function ($scope, $elm, $attrs) {
        const useMoment = $scope.useMoment === 'true';

        let currentInterval = null;

        function updateText() {
            const timeInt = _.parseInt($attrs.time);
            let txt;

            if (useMoment) {
                const time = moment(timeInt);
                txt = time.fromNow();
            } else {
                const time = new Date(timeInt);
                txt = $filter('relativeDate')(time);
            }

            $elm.text(txt);
        }

        $scope.$watch($attrs.time, function (newValue) {
            if (newValue) {
                updateText();
            }
        });

        $scope.$watch($attrs.interval, function (newValue) {
            if (newValue) {
                if (currentInterval) {
                    $interval.cancel(currentInterval);
                }

                let intervalInMilliseconds = _.parseInt($attrs.interval) * 1000 * 60;

                currentInterval = $interval(updateText, intervalInMilliseconds);
            }
        });

        $elm.on('$destroy', function () {
            $interval.cancel(currentInterval);
        });
    };

    return {
        restrict: 'E',
        scope: {
            useMoment: '@?'
        },
        link: linkFunction
    };
};

angular.module('umCore')
    .directive('uiReloadRelativeTime', UIReloadRelativeTimeDirective);
